import React, { useEffect } from "react";
import { object, array, bool, number, string } from "prop-types";
import { connect } from "react-redux";
import { get } from "lodash";
import { StoryElement } from "@quintype/components";

import AlsoRead from "../../molecules/also-read";
import QuintIcon from "../../atoms/icons/quint-icon";
import FitColorLogo from "../../atoms/icons/fit-color-logo";
import FirstPublished from "../../atoms/first-published";
import ImageGallery from "./image-gallery";
import ImageSlider from "./image-slider";
import BottomStoryElements from "./bottom-story-elements";
import ReadFullArticle from "../story-elements/read-full-article";
import { AdFree, StoryResponsiveContainer } from "../../rows/ad-free";

import { addNoFollowAttribute } from "../../helper/add-no-follow-attribute";

import translate from "../../translate";

import "./story-elements.m.css";

const AdSlot = ({ mobile, story }) => (
  <AdFree>
    <StoryResponsiveContainer desktop="storyContentDesktop" mobile={mobile} story={story} />
  </AdFree>
);

AdSlot.propTypes = {
  mobile: string,
  story: object,
};

const getElements = (element, story, card, publisherName) => {
  useEffect(() => {
    addNoFollowAttribute();
  }, []);

  switch (element.subtype) {
    case "q-and-a":
    case "question": {
      return (
        <div styleName="question-type" key={element.id}>
          {publisherName === "fit" ? <FitColorLogo /> : <QuintIcon />}
          <StoryElement element={element} key={element.id} story={story} />
        </div>
      );
    }
    case "summary": {
      return (
        <div styleName="summary-type" key={element.id}>
          <div styleName="sanpshot">{translate(publisherName, "snapshot")}</div>
          <StoryElement element={element} key={element.id} story={story} />
        </div>
      );
    }
    case "also-read": {
      return (
        <StoryElement
          renderTemplates={{ "also-read": AlsoRead }}
          publisherName={publisherName}
          element={element}
          story={story}
          key={element.id}
        />
      );
    }
    case "image-gallery": {
      if (element.metadata.type === "slideshow") {
        return <ImageSlider element={element} key={element.id} />;
      } else {
        return <ImageGallery element={element} card={card} story={story} key={element.id} />;
      }
    }
    default:
      return <StoryElement element={element} key={element.id} story={story} />;
  }
};

getElements.propTypes = {
  card: object,
  story: object,
  publisherName: string,
};

export const Card = ({ card, story, publisherName }) => {
  return (
    <div styleName="card" key={card.id} id={card.id}>
      {card["story-elements"].map((element) => getElements(element, story, card, publisherName))}
    </div>
  );
};

Card.propTypes = {
  card: object,
  story: object,
  publisherName: string,
};

const StoryElements = ({ index, story, cards, disableBodyAds, publisherName }) => {
  if (!(cards && cards.length)) return null;

  return (
    <div>
      <ReadFullArticle storyIndex={index}>
        {cards.map((card, index) => (
          <div key={index}>
            <Card card={card} story={story} publisherName={publisherName} />
            {index === 2 ? <AdSlot mobile="storyPrem2" story={story} /> : null}
            {index === 4 && !disableBodyAds ? <AdSlot mobile="storyATF" story={story} /> : null}
            {index > 5 && index % 2 === 0 && !disableBodyAds ? <AdSlot mobile="storyBTF" story={story} /> : null}
          </div>
        ))}
        <FirstPublished story={story} />
      </ReadFullArticle>
      <BottomStoryElements story={story} index={index} />
    </div>
  );
};

StoryElements.propTypes = {
  story: object,
  cards: array,
  disableBodyAds: bool,
  index: number,
  publisherName: string,
};

StoryElements.defaultProps = {
  disableBodyAds: false,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

export default connect(mapStateToProps, null)(StoryElements);
